<template>
  <section class="py-10 md:py-20 bg-gray-50 reveal active">
    <QuickShopModal ref="QuickShopModal" />
    <div class="px-5 mx-auto max-w-7xl">
      <div class="flex items-end justify-between mb-10">
        <div>
          <h2 class="text-2xl font-bold text-gray-900">最新上架</h2>
          <p class="mt-2 text-sm text-gray-500">精選推薦給您的熱門商品</p>
        </div>
        <router-link to="/collections"
          class="text-sm font-medium border-b border-black pb-0.5 hover:text-gray-600 hover:border-gray-600 transition-colors">查看全部</router-link>
      </div>

      <div class="grid grid-cols-2 gap-6 lg:grid-cols-4" id="recommend-grid">
        <div class="" v-for="(item, item_index) in getProductListData(product_data)" :key="`product_${item_index}`">
          <ProductCard :product_data="item" @open-quick-shop="OpenQuickShop" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getProductListData } from "@/common/data_convert";
import ProductCard from "@/components/productList/ProductCard.vue";
import QuickShopModal from "@/components/productList/QuickShopModal.vue";
export default {
  name: "ProductListSection",
  components: {
    ProductCard,
    QuickShopModal,
  },
  props: {
    title: {
      type: String,
    },
    product_data: {
      type: Array,
    },
  },
  methods: {
    getProductListData,
    OpenQuickShop(id) {
      this.$refs.QuickShopModal.Open(id);
    },
    GetDiscount(item) {
      let discount_type_list = [];
      item.Discount.forEach((discount) => {
        if (discount.Status != "N" && new Date() < new Date(discount.EndTime)) {
          if (discount.DiscountType == "D") {
            discount_type_list.indexOf("免運") == -1
              ? discount_type_list.push("免運")
              : "";
          } else if (discount.DiscountType == "P") {
            discount_type_list.indexOf("特價") == -1
              ? discount_type_list.push("特價")
              : "";
          } else if (discount.DiscountType == "G") {
            discount_type_list.indexOf("贈品") == -1
              ? discount_type_list.push("贈品")
              : "";
          } else if (discount.DiscountType == "S") {
            discount_type_list.indexOf("組合價") == -1
              ? discount_type_list.push("組合價")
              : "";
          }
        }
      });
      return discount_type_list;
    },
    CheckProductStockStatus(product) {
      let stock_count = 0;
      product.Stock.forEach((stock) => {
        stock.Status == "Y" ? (stock_count += stock.Stock) : "";
      });

      return stock_count <= 0 ? false : true;
    },
  },
};
</script>
